import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ILoginRequest } from 'src/app/core/interfaces/iLoginRequest';
import { TokenService } from 'src/app/core/service/autenticacao/token.service';
import { AutenticacaoService } from 'src/app/core/api/autenticacao/autenticacao.api';
import { AvisoService } from 'src/app/core/service/aviso/aviso.service';
import { CLAIMS_MODULOS, CLAIMS_PERMISSOES } from 'src/app/core/constants/claims.constants';

@Component({
  selector: 'app-auth-callback',
  template: `<p class="text-center text-lg mt-10">
    Autenticando via Gov.br...
  </p>`,
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private readonly oauthService: OAuthService,
    private readonly router: Router,
    private readonly http: HttpClient,
    private readonly autenticacaoService: AutenticacaoService,
    private readonly avisoService: AvisoService
  ) {}

  async ngOnInit() {
    try {
      await this.oauthService.loadDiscoveryDocument();
      await this.oauthService.tryLoginCodeFlow();

      const accessToken = this.oauthService.getAccessToken();
      if (!accessToken) {
        this.router.navigate(['/']);
        return;
      }

      window.history.replaceState({}, '', '/');
      const seloGov = await this.http
        .get<any[]>(environment.sgbApi, {
          headers: new HttpHeaders({
            Authorization: `Bearer ${accessToken}`,
          }),
        })
        .toPromise()
        .then((res) => res?.length  ? res.sort((a: any, b: any) => (a.id > b.id ? -1 : 1))[0].selo : 'Bronze' )
        .catch(() => 'Bronze');

      if (!environment.spgb.split(';').includes(seloGov)) {
        this.avisoService.Erro('É necessário possuir conta Gov.br nível PRATA ou superior.', 'Acesso negado');
        this.oauthService.logOut();
        this.router.navigate(['/']);
        return;
      }

      const claims: any = this.oauthService.getIdentityClaims();
      const model: ILoginRequest = {
        nome: claims.name ?? '',
        cpf: claims.preferred_username ?? '',
        senha: '',
        telefone: claims.phone_number ?? '',
        emailPessoal: claims.email ?? '',
        selo: seloGov,
      };

      this.autenticacaoService.Login(model).pipe(take(1)).subscribe({
        next: (response: any) => {
          if (response?.authenticated && response.accessToken) {
            localStorage.setItem('token', response.accessToken);
            window.history.replaceState({}, '', '/');
            if (TokenService.PossuiPermissaoGlobal(CLAIMS_PERMISSOES.DASHBOARD.VISUALIZAR)) {
              this.router.navigate(['/Dashboard']);
            } else {
              this.router.navigate(['/Inicio']);
            }
          }
          else {
            const erro = Array.isArray(response?.errors) ? response.errors.join('; ') : response?.message ?? 'Falha ao autenticar via Gov.br.';
            this.avisoService.Erro(erro, 'Erro de autenticação');
          }
        },
        error: (err: any) => {
          const errData = err?.error ?? err;
          const erro = Array.isArray(errData?.errors) ? errData.errors.join('; ') : errData?.message ?? 'Erro ao autenticar via Gov.br.';
          this.avisoService.Erro(erro, 'Erro ao tentar se autenticar');
          this.router.navigate(['/']);
        },
      });
    } catch (error) {
      window.history.replaceState({}, '', '/');
      this.avisoService.Erro('Erro ao iniciar o retorno do GOV.');
      this.router.navigate(['/']);
    }
  }
}
